import React from 'react';
import { ELEMENT_TYPES } from '../../helpers/ElementTypes';
import { PanelStickerContainer } from './styles';
const PanelSticker = ({ children }) => {
    return React.createElement(PanelStickerContainer, null, children);
};
PanelSticker.PANEL_ELEMENT = ELEMENT_TYPES.STICKER;
export { PanelSticker };
//# sourceMappingURL=PanelSticker.js.map